import React, { Component } from "react";
import Footer from "../components/Footer";
import Mainmenu from "../components/Mainmenu";
import Navbar from "../components/Navbar";
import SettingsGeneralContent from "./SettingsGeneralContent";

export default class SettingsGeneral extends Component {
  render() {
    return (
      <div className="wrapper">
        <Navbar />
        <Mainmenu />
        <SettingsGeneralContent />
        <Footer />
      </div>
    );
  }
}
